import { useCallback, useState } from 'react';
import { DataToEditType } from 'components/common/ContactFieldManager/ContactInfoForm';
import { ContactInfoCardDataType } from 'typings/form';

export const useContactInfoCard = ({ onContactRowEdit }: { onContactRowEdit: (id: string) => void }) => {
  const [copyStatus, setCopyStatus] = useState<Record<string, boolean>>({});
  const [editData, setEditData] = useState<DataToEditType | undefined>(undefined);

  const onCopy = useCallback((value: string) => {
    navigator.clipboard.writeText(value).then(() => {
      setCopyStatus({ [value]: true });
    });
    setTimeout(() => {
      setCopyStatus({ [value]: false });
    }, 2000);
  }, []);

  const onEdit = useCallback(
    (data: ContactInfoCardDataType) => {
      if (data) {
        setEditData({
          edit_type: data.type,
          edit_value: data.value,
          id: data.id,
        });
        onContactRowEdit(data.id);
      }
    },
    [onContactRowEdit]
  );

  return {
    onEdit,
    onCopy,
    copyStatus,
    editData,
  };
};
